<template>
  <div>
    <new-user-form />
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import {
    mapState, mapActions, vuex, mapGetters
} from 'vuex';
import NewUserForm from '../../components/People/NewUserForm.vue';

export default {
    data() {
        return {
            title: 'PersonNew',
            namespace: 'People'
        };
    },
    components: {
        NewUserForm
    },
};
</script>
